import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8639d06a")

_pushScopeId("data-v-8639d06a")
const _hoisted_1 = { class: "report-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "Reports")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ReportForm = _resolveComponent("ReportForm")!
  const _component_GroupContainer = _resolveComponent("GroupContainer")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportsData, (reportData, reportType) => {
      return (_openBlock(), _createBlock(_component_GroupContainer, {
        key: reportType,
        heading: reportData.heading,
        description: reportData.description
      }, {
        default: _withId(() => [
          _createVNode(_component_ReportForm, { reportData: reportData }, null, 8, ["reportData"])
        ]),
        _: 2
      }, 1032, ["heading", "description"]))
    }), 128))
  ]))
})